import React from 'react';
import { FileText } from 'lucide-react';

/**
 * Text Article Gallery component
 * Displays available text articles for article creation
 */
function TextArticleGallery({ textArticles, onSelectArticle, isLoading }) {
  if (isLoading) {
    return (
      <div className="card card-custom p-4 mb-4">
        <div className="text-center text-white py-5">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p>Loading articles...</p>
        </div>
      </div>
    );
  }

  if (!textArticles || textArticles.length === 0) {
    return (
      <div className="card card-custom p-4 mb-4">
        <div className="text-center text-white py-5">
          <FileText size={48} className="mb-3 text-muted" />
          <p>No available articles for this sport. Select a different sport or check back later.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card card-custom p-4 mb-4">
      <div className="d-flex align-items-center gap-2 mb-4">
        <FileText size={20} className="text-primary" />
        <h5 className="text-white mb-0">Available Articles ({textArticles.length})</h5>
      </div>

      <div className="row g-3">
        {textArticles.map((article) => (
          <div key={article.TextMetadataID} className="col-12 col-md-6 col-lg-4">
            <div
              className="media-card h-100"
              onClick={() => onSelectArticle(article)}
              style={{ cursor: 'pointer' }}
            >
              <div className="p-3 bg-dark rounded d-flex flex-column h-100">
                <div className="d-flex align-items-start gap-2 mb-2">
                  <span className="badge bg-success">
                    <FileText size={12} />
                  </span>
                  <h6 className="text-white mb-0 flex-grow-1" style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical'
                  }}>
                    {article.HeadLine}
                  </h6>
                </div>

                <p className="text-muted small mb-2 flex-grow-1" style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical'
                }}>
                  {article.BodyText}
                </p>

                <div className="d-flex justify-content-between align-items-center mt-auto">
                  <small className="text-muted">
                    {new Date(article.CreationDate).toLocaleDateString()}
                  </small>
                  <small className="text-primary">Click to select</small>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TextArticleGallery;
